import { Fragment } from 'react';
import { Trans } from '@lingui/react/macro';
import { Chip, Menu } from '@pocketlaw/tetris';
import { MenuMultiSelectItem } from './MenuMultiSelectItem';
import { useSearchableMenu } from './SearchableMenuContext';
import { SearchableMenuGroupedItems } from './SearchableMenuGroupedItems';
import { SearchableMenuListState } from './SearchableMenuListState';
function flattenLeafItems(nodes) {
    return nodes.flatMap((node) => {
        var _a;
        if (node.kind === 'group') {
            const children = (_a = node.children) !== null && _a !== void 0 ? _a : [];
            return flattenLeafItems(children);
        }
        return [node];
    });
}
export function SearchableMenuMultiSelectList(props) {
    const { selected = [], disabledIds = [], renderItem, onSelect, flat = true, emptyComponent, errorComponent, renderListWrapper = true, } = props;
    const { items, searching, error } = useSearchableMenu();
    const allLeafItems = flattenLeafItems(items);
    const selectedItems = selected
        .map((sId) => allLeafItems.find((item) => item.id === sId))
        .filter(Boolean)
        .sort((a, b) => {
        const aDisabled = disabledIds.includes(a.id);
        const bDisabled = disabledIds.includes(b.id);
        if (aDisabled && !bDisabled) {
            return 1;
        }
        if (!aDisabled && bDisabled) {
            return -1;
        }
        return 0;
    });
    const hasSelectedItems = Boolean(selectedItems.length);
    const displaySelectedItems = selected && hasSelectedItems && !searching;
    const listItem = (item) => {
        const isDisabled = disabledIds.includes(item.id);
        const isSelected = selected.includes(item.id);
        const renderItemHelpers = {
            disabled: isDisabled,
            selected: isSelected,
        };
        if (renderListWrapper === false) {
            return renderItem(item, renderItemHelpers);
        }
        return (<MenuMultiSelectItem key={item.id} disabled={isDisabled} selected={isSelected} onClick={() => onSelect === null || onSelect === void 0 ? void 0 : onSelect(item, renderItemHelpers)}>
        {renderItem(item, renderItemHelpers)}
      </MenuMultiSelectItem>);
    };
    return (<Fragment>
      {displaySelectedItems && (<Fragment>
          <Menu.Label action={<Chip size="small" appearance="secondary" secondary={selected.length}/>}>
            <Trans comment="Searchable menu multiselect list: Header">Selected</Trans>
          </Menu.Label>
          {selectedItems.map(listItem)}
          <Menu.Divider />
        </Fragment>)}

      <SearchableMenuListState error={error} errorComponent={errorComponent} empty={!allLeafItems.length} emptyComponent={emptyComponent}>
        <SearchableMenuGroupedItems nodes={items} excludeIds={selected} render={listItem} flat={flat || searching}/>
      </SearchableMenuListState>
    </Fragment>);
}
